import { applyTimezone, parseDate } from './../helpers/date';
import { DjangoProposal, parseProposal, Proposal } from './../proposal';

export class PaycheckAdvanceConfig {
  proposal: Proposal;
  availableUntil: Date;
  balance: number;
  enabled: boolean;
  fee: number;
  debtMonth: string;
  minimunTenureInMonths: number;
  currency: string;
  availableAmount: number;
  daysUntilCutoff: number;
  daysWorked: number;
  maximumAmount: number;
  minimumAmount: number;
  maximumSalaryMultiplier: number;
  maximumMonthlyAmount: number;
  netEarnings: number;
  lockedAmount: number;
  daysUntilMinimumAmount: number;
  defaultOriginationFee: number;
  message: string;
  accumulatedBonusAmount: number;
  bonusAmountPerWithdrawal: number;
  specialOriginationFee: number;
  originationFee: number;
  maxAmountForSpecialFee: number;

  constructor(data: PaycheckAdvanceConfig | DjangoPaycheckAdvanceConfig = {}) {
    if (data instanceof PaycheckAdvanceConfig) {
      bindPaychechAdvanceConfigData(this, data);
    } else {
      bindDjangoPaychechAdvanceConfigData(this, data);
    }
  }

  get canBeUsedToday() {
    const today = new Date();
    return today <= this.availableUntil;
  }
}

export function parsePaycheckAdvanceConfig(
  data?: PaycheckAdvanceConfig | DjangoPaycheckAdvanceConfig,
) {
  if (data) {
    return new PaycheckAdvanceConfig(data);
  } else {
    return undefined;
  }
}

function bindPaychechAdvanceConfigData(
  paycheckAdvance: PaycheckAdvanceConfig,
  data: PaycheckAdvanceConfig,
) {
  paycheckAdvance.proposal = data.proposal;
  paycheckAdvance.availableUntil = data.availableUntil;
  paycheckAdvance.balance = data.balance;
  paycheckAdvance.enabled = data.enabled;
  paycheckAdvance.fee = data.fee;
  paycheckAdvance.debtMonth = data.debtMonth;
  paycheckAdvance.minimunTenureInMonths = data.minimunTenureInMonths;
  paycheckAdvance.currency = data.currency;
  paycheckAdvance.availableAmount = data.availableAmount;
  paycheckAdvance.daysUntilCutoff = data.daysUntilCutoff;
  paycheckAdvance.daysWorked = data.daysWorked;
  paycheckAdvance.maximumAmount = data.maximumAmount;
  paycheckAdvance.minimumAmount = data.minimumAmount;
  paycheckAdvance.maximumSalaryMultiplier = paycheckAdvance.maximumSalaryMultiplier;
  paycheckAdvance.maximumMonthlyAmount = paycheckAdvance.maximumMonthlyAmount;
  paycheckAdvance.netEarnings = data.netEarnings;
  paycheckAdvance.lockedAmount = data.lockedAmount;
  paycheckAdvance.daysUntilMinimumAmount = data.daysUntilMinimumAmount;
  paycheckAdvance.defaultOriginationFee = data.defaultOriginationFee;
  paycheckAdvance.message = data.message;
  paycheckAdvance.accumulatedBonusAmount = data.accumulatedBonusAmount;
  paycheckAdvance.bonusAmountPerWithdrawal = data.bonusAmountPerWithdrawal;
  paycheckAdvance.specialOriginationFee = data.specialOriginationFee;
  paycheckAdvance.originationFee = data.originationFee;
  paycheckAdvance.maxAmountForSpecialFee = data.maxAmountForSpecialFee;
}

//////////////////////
/// DJANGO SUPPORT ///
//////////////////////
export interface DjangoPaycheckAdvanceConfig {
  proposal?: string | DjangoProposal;
  available_until?: string;
  balance?: number;
  enabled?: boolean;
  fee?: number;
  debt_month?: string;
  minimun_tenure_in_months?: number;
  currency?: string;
  available_amount?: number;
  days_until_cutoff?: number;
  days_worked?: number;
  maximum_amount?: number;
  minimum_amount?: number;
  maximum_salary_multiplier?: number;
  maximum_monthly_amount?: number;
  net_earnings?: number;
  locked_amount?: number;
  days_until_minimum_amount?: number;
  default_origination_fee?: number;
  message?: string;
  bonus_amount_per_withdrawal?: number;
  accumulated_bonus_amount?: number;
  special_origination_fee?: number;
  origination_fee?: number;
  max_amount_for_special_fee?: number;
}

function bindDjangoPaychechAdvanceConfigData(
  paycheckAdvance: PaycheckAdvanceConfig,
  data: DjangoPaycheckAdvanceConfig,
) {
  paycheckAdvance.proposal = parseProposal(data.proposal);
  paycheckAdvance.availableUntil = applyTimezone(parseDate(data.available_until), 0);
  paycheckAdvance.balance = data.balance;
  paycheckAdvance.enabled = data.enabled;
  paycheckAdvance.fee = data.fee;
  paycheckAdvance.debtMonth = data.debt_month;
  paycheckAdvance.minimunTenureInMonths = data.minimun_tenure_in_months;
  paycheckAdvance.currency = data.currency;
  paycheckAdvance.availableAmount = data.available_amount;
  paycheckAdvance.daysUntilCutoff = data.days_until_cutoff;
  paycheckAdvance.daysWorked = data.days_worked;
  paycheckAdvance.maximumAmount = data.maximum_amount;
  paycheckAdvance.minimumAmount = data.minimum_amount;
  paycheckAdvance.maximumSalaryMultiplier = data.maximum_salary_multiplier;
  paycheckAdvance.maximumMonthlyAmount = data.maximum_monthly_amount;
  paycheckAdvance.netEarnings = data.net_earnings;
  paycheckAdvance.lockedAmount = data.locked_amount;
  paycheckAdvance.daysUntilMinimumAmount = data.days_until_minimum_amount;
  paycheckAdvance.defaultOriginationFee = data.default_origination_fee;
  paycheckAdvance.message = data.message;
  paycheckAdvance.bonusAmountPerWithdrawal = data.bonus_amount_per_withdrawal;
  paycheckAdvance.accumulatedBonusAmount = data.accumulated_bonus_amount;
  paycheckAdvance.specialOriginationFee = data.special_origination_fee;
  paycheckAdvance.originationFee = data.origination_fee;
  paycheckAdvance.maxAmountForSpecialFee = data.max_amount_for_special_fee;
}
